import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './components/dashboard/Dashboard';
import Tasks from './components/tasks/Tasks';
import Interviews from './components/interviews/Interviews';
import Callings from './components/callings/Callings';
import Meetings from './components/meetings/Meetings';
import MeetingDetail from './components/meetings/MeetingDetail';
import Settings from './components/settings/Settings';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/tarefas" element={<Tasks />} />
          <Route path="/entrevistas" element={<Interviews />} />
          <Route path="/chamados" element={<Callings />} />
          <Route path="/reunioes" element={<Meetings />} />
          <Route path="/reunioes/:id" element={<MeetingDetail />} />
          <Route path="/configuracoes" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
